import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import moment from 'moment';

const initialState = {
  services: { count: 0, rows: [] },
  servicesByEquipment: { count: 0, rows: [] },
  loadingMoreServicesByEquipment: false,
  servicesFilter: {},
  servicesSelected: [],
  service: {},
  loading: false,
  checkDelete: {},
  // filter  
  startDate: moment().subtract(1, 'months'),
  endDate: null,
  filteredModels: [],
  filteredGroups: [],
  filteredPlaces: [],
  filteredAreas: [],
  filteredCompanies: [],
  filteredServiceTypes: [],
  filteredFrequencies: [],
  filteredUsers: [],
  filteredEquipment: null,
  equipmentsForFilter: [],
  loadingEquipments: false,
  filteredSources: [],
  filteredDoneInDelay: false,
};

const setServicesFilter = (state, action) => {
  return updateObject(state, {
    servicesFilter: action.servicesFilter,
  });
};

const setServicesSelected = (state, action) => {
  return updateObject(state, {
    servicesSelected: action.servicesSelected,
  });
};

const clearServicesSelected = (state, action) => {
  return updateObject(state, {
    servicesSelected: [],
  });
};

const requestServicesStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchServicesSuccess = (state, action) => {
  return updateObject(state, {
    services: action.services,
    loading: false
  });
};

const fetchServicesByEquipmentSuccess = (state, action) => {
  return updateObject(state, {
    servicesByEquipment: action.services,
    loading: false
  });
};

const fetchMoreServicesByEquipmentStart = (state) => {
  return updateObject(state, { loadingMoreServicesByEquipment: true });
};

const fetchMoreServicesByEquipmentSuccess = (state, action) => {
  return updateObject(state, {
    servicesByEquipment: {
      count: action.services.count,
      rows: [...state.servicesByEquipment.rows, ...action.services.rows],
    },
    loadingMoreServicesByEquipment: false,
  });
};

const fetchMoreServicesByEquipmentFail = (state, action) => {
  return updateObject(state, { loadingMoreServicesByEquipment: false, error: action.error });
};

const fetchCompanyByIdSuccess = (state, action) => {
  return updateObject(state, {
    service: action.service,
    loading: false
  });
}

const requestServicesFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deleteServicesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const checkDeleteServicesSuccess = (state, action) => {
  return updateObject(state, {
    checkDelete: action.checkDelete,
    loading: false
  });
}

const updateServicesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const postServicesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

// filter
const filterServicePlaces = (state, action) => {
  return updateObject(state, { filteredPlaces: action.places });
}

const filterServicePlacesRemove = (state, action) => {
	let arr = [...state.filteredPlaces];
	const filteredPlaces = arr.filter(place => place.value !== action.place.value)
  return updateObject(state, { filteredPlaces });
}

const filterServiceAreas = (state, action) => {
  return updateObject(state, { filteredAreas: action.areas });
}

const filterServiceAreasRemove = (state, action) => {
	let arr = [...state.filteredAreas];
	const filteredAreas = arr.filter(area => area.value !== action.area.value)
  return updateObject(state, { filteredAreas });
}

const filterServiceCompanies = (state, action) => {
  return updateObject(state, { filteredCompanies: action.companies });
}

const filterServiceCompaniesRemove = (state, action) => {
  
	let arr = [...state.filteredCompanies];
	const filteredCompanies = arr.filter(company => company.value !== action.companies.value)
  return updateObject(state, { filteredCompanies });
}

const filterServiceServiceTypes = (state, action) => {
  return updateObject(state, { filteredServiceTypes: action.serviceTypes });
}

const filterServiceServiceTypesRemove = (state, action) => {
	let arr = [...state.filteredServiceTypes];
	const filteredServiceTypes = arr.filter(serviceType => serviceType.value !== action.serviceType.value)
  return updateObject(state, { filteredServiceTypes });
}

const filterServiceFrequencies = (state, action) => {
  return updateObject(state, { filteredFrequencies: action.frequencies });
}

const filterServiceFrequenciesRemove = (state, action) => {
	let arr = [...state.filteredFrequencies];
	const filteredFrequencies = arr.filter(frequency => frequency.value !== action.frequency.value)
  return updateObject(state, { filteredFrequencies });
}

const filterServiceUsers = (state, action) => {
  return updateObject(state, { filteredUsers: action.users });
}

const filterServiceUsersRemove = (state, action) => {
	let previousFilteredUsers = [...state.filteredUsers];
	const filteredUsers = previousFilteredUsers.filter(user => user.value !== action.user.value)
  return updateObject(state, { filteredUsers });
}

const filterServiceModels = (state, action) => {
  return updateObject(state, { filteredModels: action.models });
}

const filterServiceModelsRemove = (state, action) => {
	let arr = [...state.filteredModels];
	const filteredModels = arr.filter(model => model.value !== action.model.value)
  return updateObject(state, { filteredModels });
}

const filterServiceGroups = (state, action) => {
  return updateObject(state, { filteredGroups: action.groups });
}

const filterServiceGroupsRemove = (state, action) => {
	let arr = [...state.filteredGroups];
	const filteredGroups = arr.filter(group => group.value !== action.group.value)
  return updateObject(state, { filteredGroups });
}

const filterServiceStartDate = (state, action) => {
  let startDate = action.startDate;
  return updateObject(state, { startDate });
}

const filterServiceStartDateRemove = (state, action) => {
  return updateObject(state, { startDate: null });
}

const filterServiceEndDate = (state, action) => {
  let endDate = action.endDate;
  return updateObject(state, { endDate });
}

const filterServiceEndDateRemove = (state, action) => {
  return updateObject(state, { endDate: null });
}

const filterServiceClear = (state, action) => {
  return updateObject(
    state,
    { 
      filteredPlaces: [],
      filteredAreas: [],
      filteredServiceTypes: [],
      filteredFrequencies: [],
      filteredModels: [],
      filteredGroups: [],
      filteredCompanies: [],
      filteredUsers: [],
      startDate: null,
      endDate: null ,
      filteredEquipment: null,
      filteredSources: [],
      filteredDoneInDelay: false,
    }
  );
}

const fetchEquipmentsStart = (state) => {
  return updateObject(state, { loadingEquipments: true });
}

const fetchEquipmentsSuccess = (state, action) => {
  return updateObject(state, { loadingEquipments: false, equipmentsForFilter: action.payload });
}

const fetchEquipmentsFail = (state) => {
  return updateObject(state, { loadingEquipments: false });
}

const filterServiceEquipment = (state, action) => {
  return updateObject(state, { filteredEquipment: action.payload });
}

const filterServiceSources = (state, action) => {
  return updateObject(state, { filteredSources: action.sources });
}

const filterServiceDoneInDelay = (state, action) => {
  return updateObject(state, { filteredDoneInDelay: action.doneInDelay });
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_SERVICES_START: return requestServicesStart(state, action);
    case actionTypes.FETCH_SERVICES_SUCCESS: return fetchServicesSuccess(state, action);
    case actionTypes.FETCH_SERVICES_BY_ID_SUCCESS: return fetchCompanyByIdSuccess(state, action);
    case actionTypes.REQUEST_SERVICES_FAIL: return requestServicesFail(state, action);
    case actionTypes.DELETE_SERVICES_SUCCESS: return deleteServicesSuccess(state, action);
    case actionTypes.CHECK_DELETE_SERVICES_SUCCESS: return checkDeleteServicesSuccess(state, action);
    case actionTypes.UPDATE_SERVICES_SUCCESS: return updateServicesSuccess(state, action);
    case actionTypes.POST_SERVICES_SUCCESS: return postServicesSuccess(state, action);
    case actionTypes.FETCH_SERVICES_BY_EQUIPMENT_SUCCESS: return fetchServicesByEquipmentSuccess(state, action);
    case actionTypes.FETCH_MORE_SERVICES_BY_EQUIPMENT_START: return fetchMoreServicesByEquipmentStart(state, action);
    case actionTypes.FETCH_MORE_SERVICES_BY_EQUIPMENT_SUCCESS: return fetchMoreServicesByEquipmentSuccess(state, action);
    case actionTypes.FETCH_MORE_SERVICES_BY_EQUIPMENT_FAIL: return fetchMoreServicesByEquipmentFail(state, action);
    case actionTypes.SET_SERVICES_FILTER: return setServicesFilter(state, action);
    case actionTypes.SET_SERVICES_SELECTED: return setServicesSelected(state, action);
    case actionTypes.CLEAR_SERVICES_SELECTED: return clearServicesSelected(state, action);
    // Filter
    case actionTypes.FILTER_SERVICE_PLACES: return filterServicePlaces(state, action);
    case actionTypes.FILTER_SERVICE_PLACES_REMOVE: return filterServicePlacesRemove(state, action);
    case actionTypes.FILTER_SERVICE_COMPANIES: return filterServiceCompanies(state, action);
    case actionTypes.FILTER_SERVICE_COMPANIES_REMOVE: return filterServiceCompaniesRemove(state, action);
    case actionTypes.FILTER_SERVICE_AREAS: return filterServiceAreas(state, action);
    case actionTypes.FILTER_SERVICE_AREAS_REMOVE: return filterServiceAreasRemove(state, action);
    case actionTypes.FILTER_SERVICE_SERVICE_TYPES: return filterServiceServiceTypes(state, action);
    case actionTypes.FILTER_SERVICE_SERVICE_TYPES_REMOVE: return filterServiceServiceTypesRemove(state, action);
    case actionTypes.FILTER_SERVICE_FREQUENCIES: return filterServiceFrequencies(state, action);
    case actionTypes.FILTER_SERVICE_FREQUENCIES_REMOVE: return filterServiceFrequenciesRemove(state, action);
    case actionTypes.FILTER_SERVICE_USERS: return filterServiceUsers(state, action);
    case actionTypes.FILTER_SERVICE_USERS_REMOVE: return filterServiceUsersRemove(state, action);
    case actionTypes.FILTER_SERVICE_MODELS: return filterServiceModels(state, action);
    case actionTypes.FILTER_SERVICE_MODELS_REMOVE: return filterServiceModelsRemove(state, action);
    case actionTypes.FILTER_SERVICE_GROUPS: return filterServiceGroups(state, action);
    case actionTypes.FILTER_SERVICE_GROUPS_REMOVE: return filterServiceGroupsRemove(state, action);
    case actionTypes.FILTER_SERVICE_CLEAR: return filterServiceClear(state, action);
    case actionTypes.FILTER_SERVICE_START_DATE: return filterServiceStartDate(state, action);
    case actionTypes.FILTER_SERVICE_START_DATE_REMOVE: return filterServiceStartDateRemove(state, action);
    case actionTypes.FILTER_SERVICE_END_DATE: return filterServiceEndDate(state, action);
    case actionTypes.FILTER_SERVICE_END_DATE_REMOVE: return filterServiceEndDateRemove(state, action);
    case actionTypes.FILTER_SERVICE_EQUIPMENT: return filterServiceEquipment(state, action);
    case actionTypes.FILTER_SERVICE_SOURCES: return filterServiceSources(state, action);
    case actionTypes.FILTER_SERVICE_DONE_IN_DELAY: return filterServiceDoneInDelay(state, action);
    case actionTypes.SERVICES_TABLE_FETCH_EQUIPMENTS_START: return fetchEquipmentsStart(state);
    case actionTypes.SERVICES_TABLE_FETCH_EQUIPMENTS_SUCCESS: return fetchEquipmentsSuccess(state, action);
    case actionTypes.SERVICES_TABLE_FETCH_EQUIPMENTS_FAIL: return fetchEquipmentsFail(state);

    default: return state;
  }
};

export default reducer;